import { render, staticRenderFns } from "./BasketListItem.vue?vue&type=template&id=3c2c335e&"
import script from "./BasketListItem.vue?vue&type=script&lang=js&"
export * from "./BasketListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2c335e')) {
      api.createRecord('3c2c335e', component.options)
    } else {
      api.reload('3c2c335e', component.options)
    }
    module.hot.accept("./BasketListItem.vue?vue&type=template&id=3c2c335e&", function () {
      api.rerender('3c2c335e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/list/BasketListItem.vue"
export default component.exports